import { AdPlacementsComponentTypes } from '@bingads-webui-campaign-react/ad-placement-consts';

const audienceWide191100Raw = {
  componentType: AdPlacementsComponentTypes.AdPlacementPreview,
  key: 'msan_191x100',
  className: 'msan_191x100',
  aspectRatio: 1.91,
  type: 'Image191x100',
  associationType: 'LandscapeImageMedia',
  imagePreviewHeight: 200,
  isRequired: true,
  minimumRequirements: 1,
  minSize: [703, 368],
  maxSize: [0, 0],
  localizedText: {
    previewTypeStringKey: _TL_('MSN feed'),
    stringKey: _TL_('1.91:1'),
  },
  previewSettings: {
    showAdsLabelWithBusinessName: true,
    showBusinessName: true,
    showImage: true,
    showShortHeadline: true,
    showDescription: true,
    showAdditionalDisclaimer: true,
    showShortHeadlineMultiline: true,
    showUrlMultiline: true,
    showMultipleDescription: true,
    showPreviewTypeString: false,
  },
  styleOverrides: {
    businessNameWithAds: {
      padding: '1px 0',
      marginTop: 9,
      '& .adslabel': {
        border: '.5px solid #78718a',
        color: '#78718a',
        fontSize: 10,
        fontWeight: 400,
        lineHeight: '13.64px',
        textDecorationThickness: 'auto',
        textSizeAdjust: '100%',
        borderRadius: '4px',
        background: '#fff',
        padding: '.8px 4px',
        margin: '0 5px 0 0',
      },
      '& .business-name': {
        color: '#333',
        fontSize: 11,
        lineHeight: '15.004px',
        padding: '1px 0',
      },
    },
    description: {
      height: 45,
      margin: '5px 0 10px 0',
      fontSize: 14,
      maxWidth: 330,
    },
    previewContent: {
      margin: 'auto',
      background: '#fff',
      border: 'solid',
      borderWidth: 'thin',
      color: '#ddd',
    },
    shortHeadline: {
      fontSize: 18,
      lineHeight: '1.2',
      height: 60,
      position: 'relative',
      top: -6,
      color: '#207697',
      maxWidth: 330,
    },
    textContainer: {
      padding: '10px',
      color: '#333',
    },
  },
};

export default audienceWide191100Raw;
